import AuthHandler from "helpers/context/Authentication/AuthHandler";
import React, { PropsWithChildren } from "react";


export interface IAuthenticationInfo {

    signedIn: boolean;
    signedInWithOnlineAckToken: boolean;
    signedInWithBearerToken: boolean;
    timedOut: boolean;

};

const initialState: IAuthenticationInfo = {
    signedIn: false,
    signedInWithOnlineAckToken: false,
    signedInWithBearerToken: false,
    timedOut: false,
};


export enum TimeoutActionEnum {
    SetSignin,
    SetSigninWithOnlineAckToken,
    TimedOut,
    Reset,
    SetSignInWithBearerToken
}

export type TimeoutAction =
    { action: TimeoutActionEnum.SetSignin, value: boolean } |
    { action: TimeoutActionEnum.SetSigninWithOnlineAckToken, value: boolean } |
    { action: TimeoutActionEnum.TimedOut } |
    { action: TimeoutActionEnum.Reset } | 
    { action: TimeoutActionEnum.SetSignInWithBearerToken, value: boolean }


const AuthReducer: (state: IAuthenticationInfo, action: TimeoutAction) => IAuthenticationInfo = (state, action) => {

    switch (action.action) {

        case TimeoutActionEnum.SetSignin:
            return { ...state, signedIn: action.value };
        case TimeoutActionEnum.SetSigninWithOnlineAckToken:
            return { ...state, signedIn: action.value, signedInWithOnlineAckToken: action.value };
        case TimeoutActionEnum.TimedOut:
            return { ...state, timedOut: true };
        case TimeoutActionEnum.Reset:
            return { signedIn: false, signedInWithOnlineAckToken: false, signedInWithBearerToken: false, timedOut: false };
        case TimeoutActionEnum.SetSignInWithBearerToken:
            return { ...state, signedIn: action.value, signedInWithBearerToken: action.value };
    }
}

export const AuthHandlerContext = React.createContext<AuthHandler | undefined>(undefined);
export const AuthenticationContext = React.createContext<IAuthenticationInfo>(initialState);

const AuthenticationContextProvider = (props: PropsWithChildren<any>) => {

    const [authInfo, authDispatch] = React.useReducer(AuthReducer, initialState);

    const authHandler = React.useMemo(() => {
        return new AuthHandler(authDispatch)
    }, [authDispatch]);



    return <AuthenticationContext.Provider value={authInfo}>
        <AuthHandlerContext.Provider value={authHandler}>
            {props.children}
        </AuthHandlerContext.Provider>
    </AuthenticationContext.Provider>

};


export default AuthenticationContextProvider;